export default function _isTransformer(obj) {
  return typeof obj['@@transducer/step'] === 'function';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/es/internal/_isTransformer.js
// module id = 62
// module chunks = 23